import { Helmet } from "react-helmet-async";

interface Crumb {
  name: string;
  item: string;
}

interface SchemaMarkupProps {
  type: "Organization" | "Breadcrumb" | "Product";
  data?: any;
}

export default function SchemaMarkup({ type, data }: SchemaMarkupProps) {
  let schema: any = null;

  if (type === "Organization") {
    schema = {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "Intron Life Sciences",
      "url": "https://intronlifesciences.com",
      "logo": "https://intronlifesciences.com/img/logo.png",
      "contactPoint": {
        "@type": "ContactPoint",
        "telephone": "+91-8801230123",
        "contactType": "customer service",
        "email": "info@intronlifesciences.com"
      },
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "2nd Floor, Vamsiram Jyothi Celesta Plot # 66, Kavuri Hills, Jubilee Hills",
        "addressLocality": "Hyderabad",
        "addressRegion": "Telangana",
        "postalCode": "500033",
        "addressCountry": "IN"
      },
      "sameAs": [
        "https://www.facebook.com/intronlifesciences/",
        "https://www.linkedin.com/company/intron-life-sciences/"
      ]
    };
  } else if (type === "Breadcrumb" && Array.isArray(data)) {
    schema = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": data.map((crumb: Crumb, index: number) => ({
        "@type": "ListItem",
        "position": index + 1,
        "name": crumb.name,
        "item": crumb.item.startsWith("http") ? crumb.item : `https://intronlifesciences.com${crumb.item}`
      }))
    };
  } else if (type === "Product" && data) {
    const absoluteImg = data.image?.startsWith("http") ? data.image : `https://intronlifesciences.com${data.image}`;
    schema = {
      "@context": "https://schema.org",
      "@type": "Product",
      "name": data.name,
      "image": absoluteImg,
      "description": data.description || `High quality ${data.brand} animal health product.`,
      "brand": {
        "@type": "Brand",
        "name": "Intron Life Sciences"
      },
      "offers": {
        "@type": "AggregateOffer",
        "priceCurrency": "INR",
        "lowPrice": "0",
        "highPrice": "0",
        "offerCount": "1"
      }
    };
  }

  if (!schema) return null;

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
}
